export function pixelsToRemStr(pxValue: string): string {
	if (pxValue === 'none') {
		return 'none';
	}

	const hasPxSuffix = pxValue.endsWith('px');
	const numericPart = hasPxSuffix ? pxValue.slice(0, -2) : pxValue;

	if (!numericPart) {
		return '75rem';
	}

	let hasDigit = false;
	let dotIndex = -1;
	for (let i = 0; i < numericPart.length; i += 1) {
		const char = numericPart[i];
		if (char >= '0' && char <= '9') {
			hasDigit = true;
			continue;
		}
		if (char === '.' && dotIndex === -1) {
			dotIndex = i;
			continue;
		}
		return '75rem';
	}

	if (!hasDigit) {
		return '75rem';
	}

	// Keep behavior equivalent to previous regex: reject trailing decimal point.
	if (dotIndex === numericPart.length - 1) {
		return '75rem';
	}

	const numericValue = Number(numericPart);
	if (!Number.isFinite(numericValue)) {
		return '75rem';
	}
	const remValue = numericValue / 16;

	return `${remValue}rem`;
}
